export default __webpack_public_path__ + "static/media/program.14877126.svg";